import { isMockAuthEnabled } from '@/config/authMode';

interface AmplifyConfig {
  Auth: {
    Cognito: {
      userPoolId: string;
      userPoolClientId: string;
      loginWith: {
        oauth: {
          domain: string;
          scopes: string[];
          redirectSignIn: string[];
          redirectSignOut: string[];
          responseType: 'code';
        };
      };
    };
  };
}

const parseRedirectList = (value: string | undefined, fallback: string[]) => {
  if (!value) {
    return fallback;
  }

  return value
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
};

type RequiredCognitoEnv =
  | 'VITE_COGNITO_USER_POOL_ID'
  | 'VITE_COGNITO_CLIENT_ID'
  | 'VITE_COGNITO_DOMAIN';

const getRequired = (key: RequiredCognitoEnv): string => {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(`Missing required Cognito configuration: ${key}`);
  }
  return value;
};

const redirectSignIn = parseRedirectList(import.meta.env.VITE_COGNITO_REDIRECT_SIGN_IN, [
  window.location.origin,
]);
const redirectSignOut = parseRedirectList(import.meta.env.VITE_COGNITO_REDIRECT_SIGN_OUT, [
  window.location.origin,
]);

export const amplifyConfig: AmplifyConfig | null = isMockAuthEnabled
  ? null
  : {
      Auth: {
        Cognito: {
          userPoolId: getRequired('VITE_COGNITO_USER_POOL_ID'),
          userPoolClientId: getRequired('VITE_COGNITO_CLIENT_ID'),
          loginWith: {
            oauth: {
              domain: getRequired('VITE_COGNITO_DOMAIN'),
              scopes: ['email', 'openid', 'profile'],
              redirectSignIn,
              redirectSignOut,
              responseType: 'code',
            },
          },
        },
      },
    };
